import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  reportingStatements: {},
  campaignReportConfiguration: {
    summary: null,
    recommendations: [],
    published: false,
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
